
    import { Options, Vue } from 'vue-class-component';

    @Options<ApButton>({
        props: {
            modelValue: String,
            placeholder: String,
            icon: String,
            disabled: Boolean,
            inputClass: [String, Object, Array],
        },
    })
    export default class ApButton extends Vue {
        protected readonly title!: string;
        protected readonly icon!: string;
    }
